import { render, staticRenderFns } from "./ProductAutosuggestInput.vue?vue&type=template&id=466bd157"
import script from "./ProductAutosuggestInput.vue?vue&type=script&lang=js"
export * from "./ProductAutosuggestInput.vue?vue&type=script&lang=js"
import style0 from "./ProductAutosuggestInput.vue?vue&type=style&index=0&id=466bd157&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports